import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import moment from 'moment'
import Edit from '../edit'
import React from 'react'

const Overview = ({ team }, { admin }) => {

  const details = {
    audits: `maha_teams/${team.id}`,
    comments: `maha_teams/${team.id}`,
    sections: [
      {
        title: 't(Team Details)',
        items: [
          { label: 't(Title)', content: team.title },
          { label: 't(Public Domain)', content: team.public_domain }
        ]
      }
    ]
  }
  
  const unschedule = {
    label: 't(Unschedule Transition)',
    className: 'link',
    confirm: 't(Are you sure you want to unschedule this transition?)',
    request: {
      endpoint: '/api/admin/team/subscription/manage',
      method: 'PATCH',
      body: {
        operation: 'unschedule'
      }
    }
  }
  
  if(admin.team.status === 'pausing') {
    details.alert = { color: 'teal', message: (
      <>Your subscription will be paused on { moment(admin.team.transition_at).format('MM/DD/YY') }. <Button { ...unschedule } /></>
    ) }
  } else if(admin.team.status === 'canceling') {
    details.alert = { color: 'teal', message: (
      <>Your subscription will cancel on { moment(admin.team.transition_at).format('MM/DD/YY') }. <Button { ...unschedule } /></>
    ) }
  }

  return <Details { ...details } />

}

Overview.contextTypes = {
  admin: PropTypes.object
}

Overview.propTypes = {
  team: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview team={ props.team } />,
  tasks: {
    items: [
      { 
        label: 't(Edit Settings)',
        svg: 'square_pen', 
        rights: ['team:manage_team'], modal: Edit 
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
